import React from 'react'
import { Trans, WithTranslation } from 'react-i18next'
import { FiSettings } from 'react-icons/fi'
import Flex from 'typescript-styled-flex'
import {
  Label,
  Link,
  MenuElement,
} from '../../../../../components/Template/Sidebar'
import { IWithSize } from '../../../../BookingCalendar/Calendar/Calendar'
import { Mixpanel } from '../../../../../utils/Mixpanel'
import { useSelector } from 'react-redux'
import { getUserId } from '../../../../../reducers/userAccount/selectors/userAccount'

function Settings({
  className,
  size = 1,
}: IWithSize & IClassName & WithTranslation) {
  const userId = useSelector(getUserId)

  const trackClick = () => {
    Mixpanel.people.increment(userId, 'Settings Menu Opened', 1)
    Mixpanel.track('Main Menu Settings Item Used', {})
  }

  return (
    <MenuElement
      size={size}
      alignCenter={true}
      className={`${className}-button`}
    >
      <Link onClick={trackClick} size={size} to={'/settings'}>
        <Flex alignCenter={true}>
          <b>
            <FiSettings size={16 * size} />
          </b>
          <Label size={size} primary={true}>
            <Trans i18nKey={'title_activity_settings'}>Ustawienia</Trans>
          </Label>
        </Flex>
      </Link>
    </MenuElement>
  )
}

export default Settings

export interface IClassName {
  className?: string
}
